import React from "react";
import { useParams } from "react-router-dom";
import BusDetails from "../components/BusDetails";
import { sampleMicrobuses } from "../lib/vehicles";
import { useTranslation } from "../lib/i18n";
import { useSeo } from "../lib/seo";

export default function MicrobusDetailPage() {
  const { id } = useParams();
  const { t, lang } = useTranslation();

  const bus = sampleMicrobuses.find((b) => b.id === id) ?? sampleMicrobuses[0];
  if (!bus) return null;

  const title =
    lang === "lt"
      ? `Mikroautobusų nuoma: ${bus.name} | Transrentus`
      : `Minibus rental: ${bus.name} | Transrentus`;

  useSeo({ title, description: t("seoMicrobusesDesc"), path: `/microbuses/${bus.id}`, lang });

  return <BusDetails bus={bus} />;
}
